<template>
    <div id="bene-collection-container">
        <f7-list form class="form-group" v-if="showFormSet.collection">
            <f7-list-input
                input-id     ="collectionAgent"
                id           ="collectionAgentInput"
                name         ="collectionAgent"
                class        ="clickable-row use-chevron"

                :label       ="$t('beneficiary-collection-agent')"
                :placeholder ="$t('beneficiary-select-collection-agent')"
                :value       ="collectionAgent"
                @change      ="changeCollectionAgent($event.target.value);"
                v-show       ="!isCollAgentAutocomplete"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-col-agent" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownCollectionAgent" class="popover-dropdown-col-agent dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="(ca, key) in collectionAgentList"
                    :key="key"
                    selected=""
                    @click="changeCollectionAgent(key); validateInput($event.target); setInput('collectionAgent');">
                    {{ca}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="collectionAgentAutocomplete"
                name         ="collectionAgent"
                type         ="text"

                :label       ="$t('beneficiary-collection-agent')"
                :placeholder ="$t('beneficiary-select-collection-agent')"
                :value       ="collectionAgent"
                v-show       ="isCollAgentAutocomplete"
                autocomplete="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="collectionPoint"
                id           ="collectionPointInput"
                name         ="collectionPoint"
                class        ="clickable-row use-chevron"

                :label       ="$t('beneficiary-collection-point')"
                :placeholder ="$t('beneficiary-select-collection-point')"
                :value       ="collectionPoint"
                @change      ="changeCollectionPoint($event.target.value);"
                v-show       ="!isCollPointAutocomplete"
                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-col-point" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownCollectionPoint" class="popover-dropdown-col-point dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="(cp, key) in collectionPointList"
                    :key="key"
                    selected=""
                    @click="changeCollectionPoint(key); validateInput($event.target); setInput('collectionPoint');">
                    {{cp}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="collectionPointAutocomplete"
                name         ="collectionPoint"
                type         ="text"

                :label       ="$t('beneficiary-collection-point')"
                :placeholder ="$t('beneficiary-select-collection-point')"
                :value       ="collectionPoint"
                v-show       ="isCollPointAutocomplete"
                autocomplete="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {
                isCollAgentAutocomplete : false,
                isCollPointAutocomplete : false
            }
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'collectionAgent',
                'collectionAgentId',
                'collectionAgentList',
                'collectionPoint',
                'collectionPointId',
                'collectionPointList',
                'showPreloaderState',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setShowPreloaderState'
            ]),

            async init(){
                const self    = this;
                const popover1 = ".beneficiary.popover-dropdown-col-agent";
                const popoverInner1 = ".beneficiary.popover-dropdown-col-agent .popover-inner";
                const popoverId1 = "dropdownCollectionAgent";
                const inputId1 = "collectionAgent";
                const inputListId1 = "#collectionAgentInput";
                await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)

                const popover2 = ".beneficiary.popover-dropdown-col-point";
                const popoverInner2 = ".beneficiary.popover-dropdown-col-point .popover-inner";
                const popoverId2 = "dropdownCollectionPoint";
                const inputId2 = "collectionPoint";
                const inputListId2 = "#collectionPointInput";
                await self.setDropdownDirection(popover2, popoverInner2, popoverId2, inputId2, inputListId2)

                //console.log("COLL AGENT LIST LENGTH : "+ Object.keys(self.collectionAgentList).length)
                //console.log("COLL AGENT LIST : ", self.collectionAgentList)

                const app          = self.$f7;
                self.autocompleteCollAgent = app.autocomplete.create({
                    inputEl: '#collectionAgentAutocomplete',
                    openIn : 'dropdown',
                    class  : '',
                    closeOnSelect: true,
                    source : function(query, render) {
                        let results = [];
                        if(query.length === 0) {
                            //render(results);
                            self.autocompleteCollAgent.close();
                            return;
                        }else{
                            self.autocompleteCollAgent.open();
                        }

                        // Find Matched Items
                        Object.keys(self.collectionAgentList).forEach(key => {
                            if(self.collectionAgentList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(self.collectionAgentList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    },
                    on     : {
                        change : function(val){
                            //console.log("SELECTED : "+val)

                            let selectedCollAgentId = 0;
                            let entries = Object.entries(self.collectionAgentList)
                            entries.map( ([collAgentId, collAgentName]) => {
                                if(collAgentName.toString().toLowerCase() == val.toString().toLowerCase()){
                                    selectedCollAgentId = collAgentId;
                                }
                            });

                            self.changeCollectionAgent(selectedCollAgentId)
                            self.validateInput(document.getElementById("collectionAgentAutocomplete"))
                        }
                    }
                })

                if(Object.keys(self.collectionAgentList).length > 10){ // USE AUTOCOMPLETE
                    self.isCollAgentAutocomplete = true;
                }else{ // USE DROPDOWN
                    self.isCollAgentAutocomplete = false;
                }

                //console.log("COLL POINT LIST LENGTH : "+ Object.keys(self.collectionPointList).length)
                //console.log("COLL POINT LIST : ", self.collectionPointList)

                self.autocompleteCollPoint = app.autocomplete.create({
                    inputEl: '#collectionPointAutocomplete',
                    openIn : 'dropdown',
                    class  : '',
                    closeOnSelect: true,
                    source : function(query, render) {
                        let results = [];
                        if(query.length === 0) {
                            //render(results);
                            self.autocompleteCollPoint.close();
                            return;
                        }else{
                            self.autocompleteCollPoint.open();
                        }

                        // Find Matched Items
                        Object.keys(self.collectionPointList).forEach(key => {
                            if(self.collectionPointList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(self.collectionPointList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    },
                    on     : {
                        change : function(val){
                            //console.log("SELECTED : "+val)

                            let selectedCollPointId = 0;
                            let entries = Object.entries(self.collectionPointList)
                            entries.map( ([collPointId, collPointName]) => {
                                if(collPointName.toString().toLowerCase() == val.toString().toLowerCase()){
                                    selectedCollPointId = collPointId;
                                }
                            });

                            self.changeCollectionPoint(selectedCollPointId)
                            self.validateInput(document.getElementById("collectionPointAutocomplete"))
                        }
                    }
                })

                if(Object.keys(self.collectionPointList).length > 10){ // USE AUTOCOMPLETE
                    self.isCollPointAutocomplete = true;
                }else{ // USE DROPDOWN
                    self.isCollPointAutocomplete = false;
                }
            },

            changeCollectionAgent(id){
                this.$emit("changeCollectionAgent", id);
            },

            changeCollectionPoint(id){
                this.$emit("changeCollectionPoint", id);
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>